<template>
    <div>
        <Spinner mini v-if="loading" />
        <Collapse v-else :multiple-active="false" :active-index="activeIndex">
            <CollapseItem
                class="my-3"
                v-for="node in content.data"
                :id="node.id"
                :locked="handleLock(node.type)"
                :key="`plan-${node.type}-${node.id}`"
                @onSelect="handleOpenContent(node, $event)">

                <template #title><h2 class="text-muted d-flex align-items-center mb-0">
                    <span class="pr-3 mdi" :class="contentIcon(node.type)"></span>
                    {{nameHandler(node)}}
                    <span
                        v-if="node.public"
                        class="ml-auto badge badge-success"
                        @click="redirectToPublicLesson(node.id)"
                    >
                        {{ $t('content.lesson.watch_now') }}
                    </span>
                </h2></template>
                <PlanDetailsCourseCollapse v-if="node.id === id" :planId="planId" :id="id" />
            </CollapseItem>
        </Collapse>
    </div>
</template>

<script>
import Collapse from '../../argon/components/Collapse/Collapse';
import CollapseItem from '../../argon/components/Collapse/CollapseItem';
import Spinner from '../../components/Common/LoadingSpinner';
import PlanDetailsCourseCollapse from './PlanDetailsCourseCollapse';

import ContentIcons from '../../mixins/ContentIcon';

export default {
    name: 'PlanDetailsCollapse',

    props: {
        infiniteScroll: Boolean,
        plan: Boolean,
        planId: {
            type: Number,
            required: true,
        },
    },

    mixins: [
        ContentIcons,
    ],

    components: {
        Collapse,
        CollapseItem,
        Spinner,
        PlanDetailsCourseCollapse,
    },

    data() {
        return {
            id: null,
            currentType: '',
            loading: true,
            activeIndex: -1,
            content: {
                data: [],
                meta: {},
                links: {},
            },
        };
    },

    methods: {
        handleGetContent(scroll = false) {
            return window.axios
                .get(`/api/public/details/plan/${this.planId}/contents`, {
                    params: {
                        page: this.content.meta.current_page
                            ? this.content.meta.current_page
                            : 1,
                        iso: localStorage.getItem('lang'),
                    },
                })
                .then((res) => {
                    scroll
                        ? (this.content.data = [
                            ...this.content.data,
                            ...res.data.data,
                        ])
                        : (this.content.data = res.data.data);
                    this.content.meta = res.data.meta;
                    this.content.links = res.data.links;
                    const firstItem = this.content.data[0];
                    if (
                        this.content.data.length > 0 &&
                        firstItem.type === 'Course'
                    ) {
                        this.handleOpenContent(firstItem, this.content.data[0].id);
                        this.activeIndex = 0;
                    }
                })
                .catch((err) => {
                    this.$notify({
                        type: 'danger',
                        message: this.$t('common.response.error'),
                    });
                })
                .finally(() => (this.loading = false));
        },
        handleLock(nodeType) {
            if (this.locked) return true;
            if (nodeType === 'Course') return false;
            return true;
        },
        nameHandler(node) {
            if (node.type === 'Exercise') return node.translation.title;
            return node.translation.name;
        },
        handleOpenContent(node, event) {
            if (node.type === 'Course') {
                this.id = event;
            }
        },
        async redirectToPublicLesson(id) {
            return window.axios
                .get(`/api/app/public/plan/${this.planId}/lesson/${id}/signed-url`)
                .then((res) => {
                    window.location.href = res.data.url;
                })
                .catch((err) => {
                    this.$notify({
                        type: 'danger',
                        message: this.$t('common.response.error'),
                    });
                })
                .finally(() => (this.loading = false));
        },
    },

    mounted() {
        this.handleGetContent();
        window.onscroll = () => {
            const bottomOfWindow =
                Math.round(document.documentElement.scrollTop + window.innerHeight) >=
                (document.documentElement.offsetHeight - 50);
            if (bottomOfWindow) {
                if (
                    this.content.meta.current_page < this.content.meta.last_page
                ) {
                    this.content.meta.current_page++;
                    this.handleGetContent(true);
                }
            }
        };
    },
};
</script>

<style scoped>
.card {
    box-shadow: none;
    border: 1px solid #dddddd;
    border-radius: 0;
}

.accordion > .card .card-header {
    margin-bottom: 0;
}

.card .card-header {
    background: #eee;
    border-bottom: 1px solid #dddddd;
}

.card .card-body {
    border-bottom: 1px solid #dddddd;
    background: #fafafa;
}

.card-header:first-child {
    border-radius: 0;
}
</style>
